<template>
  <div class="content content-full">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">{{ $t('services') }}</h4>
      </div>

      <div class="card">
        <div class="card-body p-0">
          <table class="table mb-0">
            <thead>
              <tr>
                <th width="50%">{{ $t('service') }}</th>
                <th class="hide-mobile">{{ $t('purchase_date') }}</th>
                <th>{{ $t('last_activity') }}</th>
                <th>{{ $t('status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!loading && !services.length">
                <td colspan="3">
                  {{ $t('no_purchases_yet') }}
                </td>
              </tr>
              <tr v-for="(service, index) in services" v-bind:key="`service_${index}`">
                <td>
                  <router-link :to="`/user/services/${service._id}`">
                    {{ formatService(service) }}
                  </router-link>
                </td>
                <td class="hide-mobile">
                  {{ moment.utc(service.createdAt).format('LL') }}
                </td>
                <td>
                  {{ moment.utc(service.updatedAt).format('LL') }}
                </td>
                <td :class="{ 'text-info': service.status === 'received', 'text-success': service.status === 'delivered' }">
                  {{ $t(service.status) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Services from '../services/services'
import Filters from './utils/filters'

export default {
  name: 'UserServices',
  data () {
    return {
      defaultImage: '/static/img/img-placeholder.jpg',
      moment: moment,
      loading: true,
      services: []
    }
  },
  methods: {
    formatService: function (service) {
      let name = ''

      if (service.transaction && service.transaction.transactions[0]) {
        name = service.transaction.transactions[0].custom
      } else {
        name = service.service || service._id
      }

      return Filters.capitalizeText(name.replace(/_|-/g, ' '))
    },
    getServices: function () {
      this.loading = true

      Services.getAll().then(response => {
        this.services = response.data
        this.loading = false
      })
    }
  },
  created: function () {
    this.getServices()

    if (this.$route.query.success && this.$route.query.service_id) {
      Services.activateService(this.$route.query.service_id)
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 576px) {
  .hide-mobile {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserServices.vue